// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgHumidityLevelIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M21 4c0-.55-.45-1-1-1h-5c-.55 0-1 .45-1 1s.45 1 1 1h5c.55 0 1-.45 1-1m-1 3h-3c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1s-.45-1-1-1m0 4h-2c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1-.45 1-1s-.45-1-1-1M8.15 3.48C7.62 4.35 3 12.04 3 15c0 3.31 2.69 6 6 6s6-2.69 6-6c0-2.96-4.62-10.65-5.15-11.52-.36-.6-1.35-.6-1.71 0zM9 5.97c1.51 2.62 3.27 6.06 3.82 8.03H5.18C5.73 12.03 7.5 8.59 9 5.97" />
  </g>
);
export default SvgHumidityLevelIcon;
SvgHumidityLevelIcon.displayName = 'SvgHumidityLevelIcon';
